import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    nowActions:[],
    count: 0,
    userInfo: {},
    showNotice: true,
    nowTabIndex: 0,
    // 这个是处理回退数据丢失
    aboutMessage:{},
    articleDetail:{},
    articleDetailAll:{},
    isVip: false,
    jumpURL:""
  },
  getters:{
    geturl:function(state){
      return state.jumpURL;
    }
  },
  mutations: {
    updataJumpUrl(state,jumpUrl){
      state.jumpUrl = jumpUrl;
      sessionStorage.setItem('jumpUrl',jumpUrl);
    },
    UPDATEACTIONS(state,payload){
      state.nowActions = payload.actions;
      sessionStorage.setItem('nowActions',JSON.stringify(payload.actions));
    },
    UPDATEWORD(state){
      state.count ++;
      sessionStorage.setItem('count', state.count);
    },
    UPDATEUSERINFO(state,payload){
      state.userInfo = payload.userInfo;
      sessionStorage.setItem('userInfo',JSON.stringify(payload.userInfo));
    },
    HIDENOTICE(state){
      state.showNotice = false;
      sessionStorage.setItem('showNotice', state.showNotice);
    },
    UPDATEATBINDEX(state,payload){
      state.nowTabIndex = payload.tag;
      sessionStorage.setItem('nowTabIndex',JSON.stringify(payload.tag));
    },
    UPDATEABOUTMESSAGE(state,payload){
      state.aboutMessage = payload.aboutMessage;
      sessionStorage.setItem('aboutMessage',JSON.stringify(payload.aboutMessage));
    },
    UPDATEARTICLEDETAIL(state,payload){
      state.articleDetail = payload.articleDetail;
      sessionStorage.setItem('articleDetail',JSON.stringify(payload.articleDetail));
    },
    UPDATEARTICLEDETAILALL(state,payload){
      state.articleDetailAll = payload.articleDetailAll;
      sessionStorage.setItem('articleDetailAll',JSON.stringify(payload.articleDetailAll));
    },
    UPDATEVIP(state) {
      state.isVip = true;
    }
  },
  actions: {

  }
})
